import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../supabaseClient';

export default function AffiliateTracker() {
  const location = useLocation();
  const processedRef = useRef(false); // Pour éviter de compter 2 fois le clic en mode strict dev

  useEffect(() => {
    const checkReferral = async () => {
      const params = new URLSearchParams(location.search);
      const refCode = params.get('ref');

      // Si un code est présent dans l'URL
      if (refCode && !processedRef.current) {
        processedRef.current = true;
        console.log("🔗 Affiliation détectée :", refCode);

        // 1. Sauvegarder dans le LocalStorage (pour l'utiliser lors du paiement plus tard)
        // On le garde 30 jours (logique à gérer au moment du paiement, ici on stocke juste)
        localStorage.setItem('forfeo_affiliate_code', refCode);
        localStorage.setItem('forfeo_affiliate_date', new Date().toISOString());

        // 2. Incrémenter le compteur de clics dans la DB via la fonction RPC
        try {
          const { error } = await supabase.rpc('increment_affiliate_click', {
            ref_code: refCode
          });
          
          if (error) console.error("Erreur tracking clic:", error);
          else console.log("✅ Clic comptabilisé pour", refCode);
          
        } catch (err) {
          console.error("Erreur connexion tracking", err);
        }
      }
    };

    checkReferral();
  }, [location]);

  return null; // Ce composant ne rend rien visuellement
}
